import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Takes a Redux action and returns a correctly memoized function that will dispatch it.
 *
 * The function returned by this hook expects all the same parameters as the action creator.
 */
export function useAction<T extends (...args: Parameters<T>) => void>(
  actionCreator: T
): (...args: Parameters<T>) => void {
  const dispatch = useDispatch();
  return useCallback(
    (...args: Parameters<T>) => {
      dispatch(actionCreator(...args) as any);
    },
    [dispatch, actionCreator]
  );
}
